import { Box,  Button,  Popover, Typography } from "@mui/material";
import React, { useState } from "react";
import Chatbot from "react-chatbot-kit";
import Config from "./Config";
import MessageParser from "./MessageParser";
import ActionProvider from "./ActionProvider";
import ContactSupportIcon from '@mui/icons-material/ContactSupport';
import 'react-chatbot-kit/build/main.css';

const FitFinderChatBot = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const handleClickOpen=(event)=>
  {
    setAnchorEl(event.currentTarget);
      // setOpen(true);
  }
  const handleClose=()=>
  {
    setAnchorEl(null);
  }
  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  const saveMessages = (messages, HTMLString) => {
    localStorage.setItem('chat_messages', JSON.stringify(messages));
  };

  const loadMessages = () => {
    const messages = JSON.parse(localStorage.getItem('chat_messages'));
    return messages;
  };
  return (
    <Box style={{position: 'fixed', bottom: '20px', right: '20px'}}>
    <Button onClick={handleClickOpen} variant="contained"  style={{background: 'transparent', border: 'none', outline: 'none', cursor: 'pointer'}}>
        <ContactSupportIcon color="warning" fontSize="large" />
    </Button>
    <Popover 
    id={id}
    open={open}
    anchorEl={anchorEl}
    onClose={handleClose}
    anchorOrigin={{
      vertical: 'top',
      horizontal: 'left',
    }}>
      <Box id="slider">
      <Chatbot 
        headerText="FitFinder ChatBot"
        placeholderText="Valid Question Only"
        runInitialMessagesWithHistory= {false}
        config={Config}
        actionProvider={ActionProvider}
        messageHistory={loadMessages()}
        messageParser={MessageParser}
        saveMessages={saveMessages}/>
        </Box>
    </Popover>
    </Box>
)};

export default FitFinderChatBot;
